import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { BILLING_CONFIG } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetBillingConfigListProps {
  data: any;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getBillingConfigList = async (communityId: string, data: any) =>
  await axiosAuth.post(`${BILLING_CONFIG(communityId)}/grid`, data);

const useGetBillingConfigList = ({
  data,
  communityId,
  queryParams,
}: UseGetBillingConfigListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["billing-config-list"],
    queryFn: () => getBillingConfigList(communityId, data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetBillingConfigList;
